import type { OnboardingV2State } from '../../store/onboardingV2/types.ts';
import { isOnboardingJobBoardCoverageComplete } from '../workCoverage/jobBoardCoverageModel.ts';

export function hasWorkZonesStepCompleted(state: OnboardingV2State): boolean {
  return isOnboardingJobBoardCoverageComplete(state);
}
